import { useParams } from "react-router"

import { LearnPost, LearnSections } from "pages/learn/learn-types"

import contentfulIndex from "contentful/index.json"

import { PAGINATION_LIMIT } from "pages/learn/landing/components/post-summary-list"
import { Params } from "pages/learn/landing/components/post-summary-list"

export const usePages = () => {
  const { path } = useParams<Params>()

  const posts: LearnPost[] = contentfulIndex.post.filter(post =>
    path ? LearnSections[path as keyof typeof LearnSections] === post.section : true
  )

  const pages = Math.ceil(posts.length / PAGINATION_LIMIT)

  return { posts, pages }
}
